import {
  SEARCH_TIPS_PAGINATION,
  URL_PATH,
} from '@/api/get-search-tips/constants';
import { isrFetch } from '@/api/utils/isr-fetch';
import { REVALIDATE_PERIOD } from '@/_constants/env';
import {
  ISearchTipsServerResponse,
  TGetSearchTipsRequestParams,
} from './_types';

export const getSearchTips = async ({
  searchText,
  pagination = SEARCH_TIPS_PAGINATION,
  language,
  url,
}: TGetSearchTipsRequestParams): Promise<ISearchTipsServerResponse | null> =>
  isrFetch({
    url: `${url}${URL_PATH}`,
    body: JSON.stringify({
      method: 'tips',
      params: {
        searchText,
        pagination,
        language,
      },
      jsonrpc: '2.0',
    }),
    revalidate: REVALIDATE_PERIOD,
  });
